import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
  useTheme,
} from '@material-ui/core';

import { clearSessionStorage, clearToken } from '../../utils/storage.js';
import { getActiveAccount, logoutMicrosoft } from '../../auth/auth.service.js';
import { withStyles } from '@material-ui/styles';
import AuthPageLayout from '../../layouts/AuthPageLayout.js';

const styles = (theme) => ({
  card: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    padding: '40px 44px 14px 44px',
  },
  title: {
    fontWeight: 800,
    letterSpacing: -0.5,
    marginBottom: 8,
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: 0,
  },
  body: {
    padding: '18px 44px 44px 44px',
  },
  actions: {
    marginTop: 22,
  },
  logoutBtn: {
    height: 48,
    borderRadius: 8,
    fontWeight: 700,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  secondaryLink: {
    marginTop: 18,
    display: 'inline-block',
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    fontWeight: 700,
    transition: 'color 0.2s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
});

function LogoutPage({ classes }) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (loading) return;

    setLoading(true);
    // Always clear local token on logout
    clearToken();
    clearSessionStorage(); // Clear session storage as well, in case any session-specific data is stored there
    const activeAccount = getActiveAccount();

    // If MSAL is present and there's an active account, attempt MS logout (which also clears SSO cookies)
    if (activeAccount) {
      try {
        await logoutMicrosoft();
        return; // redirect will be handled by MSAL's postLogoutRedirectUri
      } catch (e) {
        // If MS logout fails, log the error but still proceed with local logout and redirect
        console.error('Microsoft logout error:', e);
      }
    }

    // If no active MS account or if MS logout fails, just redirect to home (local logout is already done by clearToken)
    window.location.href = '/' + theme.path;
  };

  return (
    <AuthPageLayout>
      <Paper className={classes.card}>
        <div className={classes.header}>
          <Typography variant="h4" className={classes.title}>
            Chiusura sessione
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            La sessione corrente verrà chiusa.
          </Typography>
        </div>

        <div className={classes.body}>
          <Box textAlign="center">
            <div className={classes.actions}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleLogout}
                className={classes.logoutBtn}
                style={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.getContrastText(
                    theme.palette.primary.main,
                  ),
                }}
              >
                {loading ? (
                  <>
                    <CircularProgress
                      size={18}
                      style={{
                        marginRight: 10,
                        color: theme.palette.getContrastText(
                          theme.palette.primary.main,
                        ),
                      }}
                    />
                    Disconnessione…
                  </>
                ) : (
                  'Esci'
                )}
              </Button>
            </div>
            <a
              href={'/' + theme.path}
              className={classes.secondaryLink}
              onClick={(e) => {
                if (loading) e.preventDefault();
              }}
            >
              Annulla
            </a>
          </Box>
        </div>
      </Paper>
    </AuthPageLayout>
  );
}

export default withStyles(styles)(LogoutPage);
